/*!
 * 
 *   bulgarian-control-numbers v1.0.5
 *   https://github.com/petarov/bulgarian-control-numbers
 * 
 *   Copyright (c) 2020 Petar Petrov (https://github.com/petarov)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 * 
 */ !function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.BGCN = t() : e.BGCN = t();
}(this, function() {
    return function(e) {
        var t = {};
        function n(r) {
            if (t[r]) return t[r].exports;
            var i = t[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(r, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return r;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            function r(e, t) {
                for(var _$n, r = 0; r < t.length; r++)(_$n = t[r]).enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, _$n.key, _$n);
            }
            n.r(t);
            var i = [
                21,
                19,
                17,
                13,
                11,
                9,
                7,
                3,
                1
            ], o = function() {
                function e(t) {
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), "string" != typeof t) throw new Error("".concat(t, " is not of type string!"));
                    this._value = t;
                }
                return function(e, t, n) {
                    t && r(e.prototype, t), n && r(e, n);
                }(e, [
                    {
                        key: "value",
                        get: function get() {
                            return this._value;
                        }
                    },
                    {
                        key: "isValid",
                        get: function get() {
                            if (10 !== this._value.length) return !1;
                            for(var _$e = 0, _$t = 0; _$t < this._value.length - 1; _$t++)_$e += ~~this._value.charAt(_$t) * i[_$t];
                            return _$e % 10 == ~~this._value.charAt(9);
                        }
                    }
                ]), e;
            }();
            function u(e, t) {
                for(var _$n, r = 0; r < t.length; r++)(_$n = t[r]).enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, _$n.key, _$n);
            }
            var a = [
                2,
                4,
                8,
                5,
                10,
                9,
                7,
                3,
                6
            ], c = function() {
                function e(t) {
                    var _$n = this;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), function(e, t, n) {
                        t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n;
                    }(this, "_parse", function() {
                        _$n._gender = 0 == ~~_$n._value.charAt(8) % 2 ? "m" : "f";
                        var _$e = ~~_$n._value.substr(4, 2), _$t = ~~_$n._value.substr(2, 2), r = ~~_$n._value.substr(0, 2);
                        40 < _$t ? (r += 2e3, _$t -= 40) : 20 < _$t ? (r += 1800, _$t -= 20) : r += 1900, _$n._birthday = {
                            year: r,
                            month: _$t,
                            day: _$e
                        };
                    }), "string" != typeof t) throw new Error("".concat(t, " is not of type string!"));
                    if (10 !== t.length) throw new Error("".concat(t, " is not of size 10!"));
                    this._value = t, this._gender = "", this._birthday = {}, this._parse();
                }
                return function(e, t, n) {
                    t && u(e.prototype, t), n && u(e, n);
                }(e, [
                    {
                        key: "value",
                        get: function get() {
                            return this._value;
                        }
                    },
                    {
                        key: "gender",
                        get: function get() {
                            return this._gender;
                        }
                    },
                    {
                        key: "birthday",
                        get: function get() {
                            return this._birthday;
                        }
                    },
                    {
                        key: "isValid",
                        get: function get() {
                            for(var _$e = 0, _$t = 0; _$t < this._value.length - 1; _$t++)_$e += ~~this._value.charAt(_$t) * a[_$t];
                            var _$n = _$e % 11;
                            return (_$n = 10 > _$n ? _$n : 0) == ~~this._value.charAt(9);
                        }
                    }
                ]), e;
            }();
            function f(e, t) {
                for(var _$n, r = 0; r < t.length; r++)(_$n = t[r]).enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, _$n.key, _$n);
            }
            var s = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8
            ], l = [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10
            ], h = [
                2,
                7,
                3,
                5
            ], b = [
                4,
                9,
                5,
                7
            ], g = function() {
                function e(t) {
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), "string" != typeof t) throw new Error("".concat(t, " is not of type string!"));
                    if (2 < t.length && "BG" == t.substr(0, 2) && (t = t.substring(2)), 9 !== t.length && 13 !== t.length) throw new Error("".concat(t, " is not of size 9 or 13!"));
                    this._value = t;
                }
                return function(e, t, n) {
                    t && f(e.prototype, t), n && f(e, n);
                }(e, [
                    {
                        key: "value",
                        get: function get() {
                            return this._value;
                        }
                    },
                    {
                        key: "isValid",
                        get: function get() {
                            for(var _$e = [], _$t = 0; _$t < this._value.length; _$t++)_$e[_$t] = ~~this._value.charAt(_$t);
                            for(var _$n = 0, r = 0; 8 > r; r++)_$n += _$e[r] * s[r];
                            var i = _$n % 11;
                            if (9 < i) {
                                _$n = 0;
                                for(var o = 0; 8 > o; o++)_$n += _$e[o] * l[o];
                                i = 9 < (i = _$n % 11) ? 0 : i;
                            }
                            if (9 === this._value.length) return i === _$e[8];
                            _$e[8] = i, _$n = 0;
                            for(var u = 8; 12 > u; u++)_$n += _$e[u] * h[u - 8];
                            if (9 < (i = _$n % 11)) {
                                _$n = 0;
                                for(var a = 8; 12 > a; a++)_$n += _$e[a] * b[a - 8];
                                i = 9 < (i = _$n % 11) ? 0 : i;
                            }
                            return i === _$e[12];
                        }
                    }
                ]), e;
            }();
            function v(e, t) {
                for(var _$n, r = 0; r < t.length; r++)(_$n = t[r]).enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, _$n.key, _$n);
            }
            var y = function() {
                function e(t) {
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), function(e, t, n) {
                        t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n;
                    }(this, "_modulo", function(e, t) {
                        for(var _$n; e.length > 10;)_$n = e.substring(0, 10), e = _$n % t + e.substring(10);
                        return e % t;
                    }), "string" != typeof t) throw new Error("".concat(t, " is not of type string!"));
                    if (22 !== (t = t.replace(/\s/g, "")).length) throw new Error("".concat(t, " is not of size ").concat(22, "!"));
                    this._value = t, this._bic = "".concat(t.substr(4, 4), "BGSF"), this._accountNo = t.substring(14);
                }
                return function(e, t, n) {
                    t && v(e.prototype, t), n && v(e, n);
                }(e, [
                    {
                        key: "value",
                        get: function get() {
                            return this._value;
                        }
                    },
                    {
                        key: "bic",
                        get: function get() {
                            return this._bic;
                        }
                    },
                    {
                        key: "accountNo",
                        get: function get() {
                            return this._accountNo;
                        }
                    },
                    {
                        key: "isValid",
                        get: function get() {
                            for(var _$e, _$t = this._value.substring(4) + this._value.substr(0, 4), _$n = [], r = 0; r < _$t.length; r++)_$e = _$t.charAt(r), _$n[r] = "a" <= _$e && "z" >= _$e ? _$e.charCodeAt(0) - 97 + 10 : "A" <= _$e && "Z" >= _$e ? _$e.charCodeAt(0) - 65 + 10 : _$e;
                            return 1 === this._modulo(_$n.join(""), 97);
                        }
                    }
                ]), e;
            }();
            function p(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            var d = function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
            };
            p(d, "personalNumber", function(e) {
                return new o(e);
            }), p(d, "pn", function(e) {
                return d.personalNumber(e);
            }), p(d, "egn", function(e) {
                return new c(e);
            }), p(d, "bulstat", function(e) {
                return "string" == typeof e && 10 === e.length ? new c(e) : new g(e);
            }), p(d, "iban", function(e) {
                return new y(e);
            }), p(d, "isValid", function(e) {
                if ("string" != typeof e) throw new Error("".concat(e, " is not of type string!"));
                switch((e = e.replace(/\s/g, "")).length){
                    case 22:
                        return d.iban(e).isValid;
                    case 9:
                    case 11:
                    case 13:
                        return d.bulstat(e).isValid;
                    case 10:
                        return d.egn(e).isValid || d.pn(e).isValid;
                }
                return !1;
            });
            t.default = d;
        }
    ]);
});
